(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerSearch = document.querySelector('.header-search-section');
      this.headerSearchMobile = document.querySelector('.header-search-section-mobile');
      this.headerLogo = document.querySelector('.header__heading-link');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.lastScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
    
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      let tolerance = 8; 

      if (scrollTop > this.lastScrollTop + tolerance && scrollTop > (this.headerBounds.bottom - 250)) {
        if (window.matchMedia("(max-width: 768px)").matches) { 
          this.header.style.top = '0px'; 
        } else {
          this.header.style.top = '35px';
        }
        this.headerSearch.style.top = '';
        this.announcementBar.style.top = '0px';
        this.headerSearchMobile.classList.remove('scrolled-up-header-search-mobile'); 
        this.header.classList.add('custom-sticky');
        this.announcementBar.classList.add('announcement-bar-sticky');
        this.headerLogo.classList.add('header__heading-link--sticky');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.lastScrollTop && scrollTop > this.headerBounds.bottom) { 
        if (window.matchMedia("(max-width: 768px)").matches) { // 768px es el tamaño de punto de interrupción para iPad, puedes ajustarlo a tus necesidades
          this.header.style.top = '0px'; // Cambia este valor a lo que necesites para móviles
        } else {
          this.header.style.top = '120px';
        }
        this.headerSearch.style.top = '35px';
        this.headerSearchMobile.classList.add('scrolled-up-header-search-mobile'); 
        this.announcementBar.style.top = '0px';
        this.header.classList.remove('custom-sticky');
        this.announcementBar.classList.add('announcement-bar-sticky');
        this.headerLogo.classList.remove('header__heading-link--sticky');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 60);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 0) {
        this.header.style.top = '0px';
        this.headerSearch.style.top = '';
        this.headerSearchMobile.style.top = '';
        this.announcementBar.style.top = '0px'; 
        this.announcementBar.classList.remove('announcement-bar-sticky');
        this.headerLogo.classList.remove('header__heading-link--sticky');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.lastScrollTop = scrollTop;
      this.currentScrollTop = scrollTop;
    }


    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
// Hover mega menu
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

  items.forEach(item => {
    let ul = item.querySelector("ul");
    let timer;

    item.addEventListener("mouseover", () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        item.setAttribute("open", true);
      }, 400); 
    });

    item.addEventListener("mouseleave", () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        item.removeAttribute("open");
      }, 400); 
    });

    ul.addEventListener("mouseleave", () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        item.removeAttribute("open");
      }, 400); 
    });
  });
  






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  var modal = document.getElementById('modalRegionComuna');
  var enlace = document.getElementById('selectLocation');
  var regionSelector = document.getElementById('regionSelector');
  var comunaSelector = document.getElementById('comunaSelector');
  var selectLocation = document.getElementById('selectLocation');

  enlace.onclick = function (event) {
    event.preventDefault();
    modal.classList.add('regionSelected');
    modal.style.display = 'block';
  };
 
  function closeModalComuna(){
    document.querySelector('.container-close').addEventListener('click', function (e) { 
      modal.classList.remove('regionSelected');
      modal.style.display = "none";  
    });
  }
  
  function checkLocalStorageAndShowModal() {
    var region = localStorage.getItem('region');
    var comuna = localStorage.getItem('comuna');
    var modal = document.getElementById('modalRegionComuna');

    if (!region || !comuna) {
      modal.style.display = 'block';
    }
  }

  function updateFormAction() {
    var form = document.getElementById('cart-form-regioncomuna');
    var regionValue = localStorage.getItem('region');
    var comunaValue = localStorage.getItem('comuna');

    if (regionValue && comunaValue) {
      form.action =
        '/cart?step=contact_information&checkout[shipping_address][country]=CL&checkout[shipping_address][province]=' +
        encodeURIComponent(regionValue) +
        '&checkout[shipping_address][city]=' +
        encodeURIComponent(comunaValue);
    }
  }

  function updateSelectLocationFromLocalStorage() {
    var region = localStorage.getItem('region');
    var comuna = localStorage.getItem('comuna');

    var iconArrow = document.querySelector('.cart-items__delivery-link svg');

    if (region && regionSelector) {
      regionSelector.value = region;
      regionSelector.dispatchEvent(new Event('change'));
    }

    if (comuna) {
      if (comunaSelector && selectLocation) {
        comunaSelector.value = comuna;
        selectLocation.innerHTML = comuna + iconArrow.outerHTML;
      }
    }
  }

  // Region y comunas
  // Obtener datos de la región y las comunas y enviar a action del formulario (Acción de boton seleccionar en modal)
  function setFormActionAndLocalStorage(event) {
    event.preventDefault();

    var regionSelector = document.getElementById('regionSelector');
    var comunaSelector = document.getElementById('comunaSelector');
    var selectButton = document.querySelector('.modal__selectButton');

    var regionValue = regionSelector.options[regionSelector.selectedIndex].value;
    var comunaValue = comunaSelector.options[comunaSelector.selectedIndex].value;

    var form = document.getElementById('cart-form-regioncomuna');
    form.action =
      '/cart?step=contact_information&checkout[shipping_address][country]=CL&checkout[shipping_address][province]=' +
      encodeURIComponent(regionValue) +
      '&checkout[shipping_address][city]=' +
      encodeURIComponent(comunaValue);

    var modal = document.getElementById('modalRegionComuna');

    if (regionSelector.value != '' && comunaSelector.value != '') {
      modal.style.display = 'none';
    }

    localStorage.setItem('region', regionValue);
    localStorage.setItem('comuna', comunaValue);
    updateSelectLocationFromLocalStorage();
  }

  function loadRegionData() {
    fetch('https://calendar-app.kitchencenter.cl/api/calendar/regions')
      .then((response) => response.json())
      .then((data) => {
        try {
          var regionMap = {};
          var regionSelector = document.getElementById('regionSelector');
          var comunaSelector = document.getElementById('comunaSelector');
          var selectButton = document.querySelector('.modal__selectButton');

          var defaultRegionOption = document.createElement('option');
          defaultRegionOption.value = '';
          defaultRegionOption.text = 'Selecciona tu región';
          defaultRegionOption.selected = true;
          defaultRegionOption.disabled = true;
          regionSelector.appendChild(defaultRegionOption);

          for (var region in data) {
            var short_code = data[region][0].short_code;
            if (short_code !== null) {
              regionMap[short_code] = data[region];
            }
          }
          for (var region in data) {
            var short_code = data[region][0].short_code;
            if (short_code !== null) {
              var option = document.createElement('option');
              option.value = short_code;
              option.text = region;
              regionSelector.appendChild(option);
            }
          }

          regionSelector.addEventListener('change', function () {
            comunaSelector.innerHTML = '';
            var defaultComunaOption = document.createElement('option');
            defaultComunaOption.value = '';
            defaultComunaOption.text = 'Selecciona tu comuna';
            defaultComunaOption.selected = true;
            defaultComunaOption.disabled = true;
            comunaSelector.appendChild(defaultComunaOption);

            var selectedRegion = regionMap[this.value];
            if (selectedRegion) {
              for (var i = 0; i < selectedRegion.length; i++) {
                var option = document.createElement('option');
                option.value = selectedRegion[i].district;
                option.text = selectedRegion[i].district;
                comunaSelector.appendChild(option);
              }
            }

            if (regionSelector.value != '' && comunaSelector.value != '') {
              selectButton.classList.remove('disabled');
            } else {
              selectButton.classList.add('disabled');
            }
          });

          comunaSelector.addEventListener('change', function () {
            if (regionSelector.value != '' && comunaSelector.value != '') {
              selectButton.classList.remove('disabled');
            } else {
              selectButton.classList.add('disabled');
            }
          });

          regionSelector.dispatchEvent(new Event('change'));
          updateSelectLocationFromLocalStorage();
        } catch (error) {
          console.error('Ocurrió un error:', error);
        }
      })
      .catch((error) => {
        console.error('Error al obtener los datos:', error);
      });
  }

  document
    .querySelector('#modalRegionComuna .modal__selectButton')
    .addEventListener('click', setFormActionAndLocalStorage);

  // updateFormAction(); 
  // loadRegionData();
  // checkLocalStorageAndShowModal();
  // closeModalComuna();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.slideshow__slide').forEach(function (element) {
    element.addEventListener('click', function () {
      var route = this.getAttribute('data-click');
      window.location.href = route;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
